import { render, staticRenderFns } from "./EditorHeaderPresentButton.vue?vue&type=template&id=77bdb29c&scoped=true&"
import script from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderPresentButton.vue?vue&type=style&index=0&id=77bdb29c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdb29c",
  null
  
)

export default component.exports